
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Add error handling to catch rendering errors
const renderApp = () => {
  try {
    // Make sure we have a valid root element to mount on
    const rootElement = document.getElementById("root");
    if (!rootElement) {
      throw new Error('Root element not found in the document!');
    } else {
      createRoot(rootElement).render(<App />);
    }
  } catch (error) {
    console.error('Failed to render application:', error);
    
    // Display a fallback UI if rendering fails
    const rootElement = document.getElementById("root");
    if (rootElement) {
      rootElement.innerHTML = `
        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; font-family: sans-serif; padding: 20px; text-align: center;">
          <h1 style="color: #e53e3e; margin-bottom: 1rem;">Application Failed to Load</h1>
          <p style="margin-bottom: 1rem;">There was a problem loading the application. Please try refreshing the page.</p>
          <button 
            style="background-color: #3182ce; color: white; padding: 0.5rem 1rem; border: none; border-radius: 0.25rem; cursor: pointer;"
            onclick="window.location.reload()">
            Reload Page
          </button>
        </div>
      `;
    }
  }
};

// Execute the render function
renderApp();
